/* Shared PDP accordion — smooth height animation for native <details class="pdp-acc">.
   Body markup: <div class="pdp-acc__body"><div class="pdp-acc__inner">…</div></div>.
   Idempotent (guards against double-load) + event delegation (works for any .pdp-acc on the page). */
(function () {
  if (window.__pdpAccInit) return;
  window.__pdpAccInit = true;

  var DURATION = 280;

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('details.pdp-acc > summary');
    if (!summary) return;
    var details = summary.parentElement;
    var body = summary.nextElementSibling;
    if (!body || !body.classList.contains('pdp-acc__body')) return;

    e.preventDefault();
    if (body.dataset.animating) return;
    body.dataset.animating = '1';

    var clear = function () {
      body.style.height = '';
      body.style.overflow = '';
      delete body.dataset.animating;
      body.removeEventListener('transitionend', onEnd);
    };
    var onEnd = function (ev) { if (ev.target === body && ev.propertyName === 'height') { if (!details.open) {} clear(); } };

    body.style.overflow = 'hidden';

    if (details.open) {
      // closing: current height -> 0, then collapse
      body.style.height = body.scrollHeight + 'px';
      body.getBoundingClientRect();
      body.style.height = '0px';
      body.addEventListener('transitionend', function h(ev) {
        if (ev.target !== body || ev.propertyName !== 'height') return;
        body.removeEventListener('transitionend', h);
        details.open = false;
        clear();
      });
    } else {
      // opening: render, then 0 -> content height
      details.open = true;
      var target = body.scrollHeight;
      body.style.height = '0px';
      body.getBoundingClientRect();
      body.style.height = target + 'px';
      body.addEventListener('transitionend', function h(ev) {
        if (ev.target !== body || ev.propertyName !== 'height') return;
        body.removeEventListener('transitionend', h);
        clear();
      });
    }
  });
})();
